export default {
      id: "kol_mest-usage",
      viewBox: "0 0 43 43",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#kol_mest",
      toString: function () {
        return this.url;
      }
    }